import Form from 'react-bootstrap/Form'

const SpeedFormValidationError = ({ meta, ...props }) => {
    return <Form.Text className="text-muted">
        {meta.touched && meta.error && props.isHidden == null ? (<div className="validation-error">{meta.error}</div>) : null}
    </Form.Text>
}

export default SpeedFormValidationError;